'use strict';

var ModalDirective = function ModalDirective() {
  return {
    restrict: 'E',
    transclude: true,
    controller: 'ModalController',
    template: require('../templates/modal.html'),
    scope: {
      modalId: '@',
      config: '=',
      caption: '='
    },
    link: function link(scope, element) {
      scope.config = scope.config || {};
      scope.config.closeButtonPresent = scope.config.closeButtonPresent || false;
      var $element = element.find('.modal.rm-modal').first();
      $element.on('show.bs.modal', function () {
        scope.setModalVisibility(true);
      });
      $element.on('hidden.bs.modal', function () {
        scope.setModalVisibility(false);
      });
      scope.$on('rm-modal:show', function (event, id) {
        if (scope.modalId === id) {
          element.find('.modal.rm-modal').modal('show');
        }
      });
    }
  };
};
ModalDirective.$inject = [];
module.exports = ModalDirective;